import type { EntityID, Grid } from "./three-d-schemas";

export {
  CAMERA_TYPE,
  entityDeclarationSchema,
  entityRegistrySchema,
  axisAngleRotationSchema,
  eulerRotationSchema,
  jointBindingSchema,
  jointMimicSchema,
  jointSchema,
  jointValueSchema,
  meshSchema,
  modelMeshSchema,
  modelNodeMeshSchema,
  pathSchema,
  quaternionRotationSchema,
  rotationSchema,
  positionBasePresetSchema,
  positionTransformationSchema,
  threeDPanelConfigSchema,
  threeDPanelDataSchema,
  vectorFieldSchema,
  type Camera,
  type OrbitCamera,
  type ThirdPersonCamera,
  type PanelData,
  type PanelConfig,
  type Path,
  type PositionTransformation,
  type PositionBasePreset,
  type Position,
  type Sphere,
  type Box,
  type EntityDeclaration,
  type EntityRegistry,
  type AxisAngleRotation,
  type EulerRotation,
  type Joint,
  type JointBinding,
  type JointMimic,
  type JointValue,
  type Mesh,
  type ModelMesh,
  type ModelNodeMesh,
  type QuaternionRotation,
  type Rotation,
  type VectorFieldDisplayMode,
  type VectorField,
  type Grid,
  type Entity,
  type EntityID,
} from "./three-d-schemas";

export { deriveSourceFileIdFromAxes, type Axes } from "./axesFile";

export {
  clampToLimits,
  evaluateJointValues,
  mimicOrder,
  type MimicOrder,
} from "./jointMimic";

export {
  ancestorChain,
  buildEntityTree,
  descendantIds,
  findParentCycle,
  resolveParent,
  topologicalOrder,
  type EntityTreeNode,
  type HierarchyEntity,
} from "./entityHierarchy";

export const DEFAULT_ENTITY_ID: EntityID = "entity0";

/**
 * The floor grid a 3D panel starts with: five-metre cells, in a mid grey with
 * the alpha that keeps it a reference rather than a wall.
 *
 * Named here, rather than written into the reducer that creates a panel, so that
 * everything which opens a 3D scene without a saved grid to restore — the panel
 * itself, and the ingest wizard's preview — starts from the same floor. Two
 * literals that happened to agree would be two literals free to stop agreeing.
 *
 * `verticalOffset` is left out: the renderer derives the grid's height from the
 * first positioned entity when none is given. A consumer that needs the key
 * present — `lodash.isEqual` counts absent and `undefined` as different — should
 * spread this and add it explicitly.
 */
export const DEFAULT_GRID: Grid = { color: "#88888888", scale: 5 };
